import { IMovimento } from "@/modelo";
import { DadosProcessoDto } from "@/modelo/dto/DadosProcessoDto";
import React, { useState } from "react";
import ViewMovimentoProcesso from "./ViewMovimentoProcesso";
import { IMovimentoInternoEsij } from "@/modelo/MovimentoInternoEsij";
import { UtilData } from "@/misc/UtilData";
import { Tabs, Tab, Box, Typography } from "@mui/material";

interface IViewMovimentoProcessoEsijProps {
  movimentos: IMovimento[];
  dadosProcesso?: DadosProcessoDto;
  movimentoInterno: IMovimentoInternoEsij[];
}

const ViewMovimentoProcessoEsij: React.FC<IViewMovimentoProcessoEsijProps> = ({
  movimentos = [],
  dadosProcesso,
  movimentoInterno = [],
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const movimentosInternos = Array.isArray(movimentoInterno) ? movimentoInterno : [];

  function primeiraLetraMaiuscula(texto: string): string {
    if (!texto) return "";
    return texto
      .toLowerCase()
      .split(" ")
      .map((palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(" ");
  }

  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        textColor="inherit"
        sx={{
          minHeight: 36,
          "& .MuiTab-root": {
            minWidth: 0,
            flex: 1,
            minHeight: 36,
            padding: "0 16px",
            color: "#6b7280",
            fontWeight: "500",
            border: "1px solid #cbd5e1",
            borderRadius: "8px 8px 0 0",
            transition: "all 0.3s ease",
          },
          "& .MuiTab-root:not(.Mui-selected):hover": {
            backgroundColor: "#bec3d194",
          },
          "& .MuiTab-root.Mui-selected": {
            color: "#ffffff",
            fontWeight: "bold",
          },
          "& .MuiTabs-indicator": {
            display: "none",
          },
        }}
      >
        <Tab label="Movimentos" />
        <Tab label="Movimentos Internos" />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {activeTab === 0 && (
          <ViewMovimentoProcesso
            movimentos={movimentos}
            dadosProcesso={dadosProcesso}
          />
        )}

        {activeTab === 1 && (
          <Box sx={{ display: "flex", flexDirection: "column", mr: 2, mt: 2 }}>
            <span
              className="titulo"
              style={{ fontWeight: "bold", marginLeft: "15px", marginBottom: "-15px" }}
            >
              Movimentos Internos:
            </span>
            {movimentosInternos.length === 0 ? (
              <Typography color="text.secondary" sx={{ ml: 2, mt: 2 }}>
                Não há movimentação interna deste processo neste gabinete.
              </Typography>
            ) : (
              <ul>
                {movimentosInternos
                  .slice()
                  .sort(
                    (a, b) =>
                      new Date(b.dataAndamentoInterno).getTime() -
                      new Date(a.dataAndamentoInterno).getTime()
                  )
                  .map((movimento, i) => (
                    <li key={i}>
                      {UtilData.dataSemHora(movimento.dataAndamentoInterno)} -{" "}
                      {movimento.descAndamento} -{" "}
                      {primeiraLetraMaiuscula(movimento.nomeServidor)}
                    </li>
                  ))}
              </ul>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ViewMovimentoProcessoEsij;